import i18n from 'i18next';

/** MultiLanguage 请求头:后端 VersionUtil.resolveLang 最优先读取(> fateuniLanguage cookie > 默认 zh-TW)。
 *  直接读 i18next 单例,避免引 '@/i18n' 在 node 测试环境触发 document.cookie 副作用。 */
export function multiLanguageHeader(): Record<string, string> {
  return { MultiLanguage: i18n.language || 'zh-TW' };
}
